export default function ({ $axios, redirect }) {
  $axios.onRequest(async (config) => {
    if (config.url !== '/web/client/getParam' && !config.url.includes('api.yotpo.com')) {
      const tokenParam = await $axios.$get('/web/client/getParam')
      $axios.setHeader('x-token-param', tokenParam)
    }
    return config
  })
}
